<template>
    <div class="notification-bar" :class="cssClasses" v-if="msg">
        <div class="container">
            <span>{{ msg }}</span>
            <span class="pull-right">
                <i class="fas fa-times" @click="dismiss"></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: { type: String, default: 'success' },
        msg: { type: String, required: true },
    },

    computed: {
        cssClasses() {
            return {
                success: this.type === 'success',
                error: this.type === 'error',
                warning: this.type === 'warning',
                info: this.type === 'info',
            }
        }
    },

    methods: {
        dismiss() {
            this.$store.dispatch('setNotification', null)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~#/globals';
.notification-bar {
    position: relative;
    height: 30px;
    line-height: 30px;
    color: #fff;

    &.success { background-color: $green; }
    &.error { background-color: $red; }
    &.warning { background-color: $warning; }

    .pull-right {
        float: right;
    }
    i {
        cursor: pointer;
    }
}
</style>
